const health = {
  HEALTH: 'HEALTH'

}
export { health }
